import React from 'react';
import { useOpts } from '../../context';
import TermsOfService, { TermsOfServiceTextVariant, } from '../../TermsOfService';
var useWizardTermsFooter = function () {
    var linkTokenPayload = useOpts().linkTokenPayload;
    return (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.skipIntroScreen) || false;
};
/**
 * Terms footer that renders in the wizard only if we haven't skipped the intro screen.
 *
 * @returns JSX.Element
 */
function WizardTermsFooter() {
    var showTerms = useWizardTermsFooter();
    if (!showTerms)
        return null;
    return React.createElement(TermsOfService, { textVariant: TermsOfServiceTextVariant.PROCEEDING });
}
export default WizardTermsFooter;
